import { ColorPicker } from '@trimble/ui-components/solidjs';
import { Component, Show } from 'solid-js';
import { Portal } from 'solid-js/web';
import type { RgbColor } from 'solid-color';
import {
  toPickerHexColor,
  type PickerPosition,
} from './createPaletteStopColorPickerControls';

export interface PaletteStopColorPickerProps {
  readonly show: boolean;
  readonly position: PickerPosition;
  readonly color: string;
  readonly testId: string;
  onSave(rgb: RgbColor): void;
  onClose(): void;
}

/**
 * Thin wrapper around the shared `ColorPicker` from `@trimble/ui-components`:
 * portals it and positions it below a swatch anchor. All colour-picking
 * behaviour is delegated to the shared component.
 */
export const PaletteStopColorPicker: Component<PaletteStopColorPickerProps> = (
  props
) => (
  <Show when={props.show}>
    <Portal>
      <div
        class="fixed z-dropdown"
        style={{
          left: `${String(props.position.left)}px`,
          top: `${String(props.position.top)}px`,
        }}
        data-testid={props.testId}
      >
        <ColorPicker
          cssAlignment=""
          initialColor={toPickerHexColor(props.color)}
          onSave={props.onSave}
          onClose={props.onClose}
        />
      </div>
    </Portal>
  </Show>
);
